import React from "react";
import "../pages/AboutUs.scss";

const policyContent = {
    titleTerms: "Terms & Conditions",
    termsIntro:
      "By accessing or using this website, you agree to comply with the following terms:",
    termsList: [
      "The text, branding, and custom design elements are property of Alterations by Sdenka and Paola. All rights reserved.",
      "You may not copy, reproduce, or distribute content without prior permission, except where covered by specific licenses.",
      "We are not liable for external site content linked from this website.",
      "These terms may be updated, and changes take effect upon posting.",
    ],
    titleWearAndTear: "Wear and Tear Policy",
    wearAndTearIntro:
      "Upon receiving your tailored garments, please inspect them and report any defects to our staff within 14 business days.",
    wearAndTearDetails:
      "We are committed to providing exceptional tailoring services, but we cannot be held responsible for damages caused by personal accidents, improper care, negligence, or normal wear and tear over time. Our warranty does not cover issues resulting from excessive use, mishandling, or natural material breakdown.",
    titleCredits: "Credits",
    creditsIntro:
      "We would like to thank the creators of the images and resources used on our website. These elements have been utilized in accordance with their respective licenses:",
    creditsPhotos: "Photos sourced from ",
    creditsIcons: "Icons Sourced from",
};

const PolicyPage = () => {
  return (
    <div className="about-us">
      <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
        <section style={{ marginBottom: "30px" }}>
          <h2>{policyContent.titleTerms}</h2>
          <p>{policyContent.termsIntro}</p>
          <ul>
            {policyContent.termsList.map((term, index) => (
              <li key={index}>{term}</li>
            ))}
          </ul>
        </section>

        <section>
          <h2>{policyContent.titleWearAndTear}</h2>
          <p>{policyContent.wearAndTearIntro}</p>
          <p>{policyContent.wearAndTearDetails}</p>
        </section>

        <section style={{ marginBottom: "30px" }}>
          <h2>{policyContent.titleCredits}</h2>
          <p>{policyContent.creditsIntro}</p>
          <ul>
            <li>
              {policyContent.creditsPhotos}:{" "}
              <a
                style={{color:"#5F4633"}}
                href="https://unsplash.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Unsplash
              </a>
              ,{" "}
              <a
                style={{color:"#5F4633"}}
                href="https://pexels.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Pexels
              </a>{" "}
              and{" "}
              <a
                style={{color:"#5F4633"}}
                href="https://pixabay.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Pixabay
              </a>
              .
            </li>
            <li>
              {policyContent.creditsIcons}:{" "}
              <a
                style={{color:"#5F4633"}}
                href="https://www.svgrepo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                SVG Repo
              </a>{" "}
              and{" "}
              <a
                style={{color:"#5F4633"}}
                href="https://icons8.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Icons8
              </a>
              .
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default PolicyPage;
